'use client'

import { Box, ButtonBase } from '@mui/material'

// Types
import type { PricingPeriodToggleProps } from '@/types/components/molecules/pricing'

// Pill switch between billing periods (monthly, yearly, ...)
const PricingPeriodToggleMolecule = (props: PricingPeriodToggleProps) => {
	// Props
	const { label, options, value, onChange } = props

	return (
		<Box
			role="radiogroup"
			aria-label={label}
			sx={{
				display: 'inline-flex',
				flexWrap: 'wrap',
				justifyContent: 'center',
				gap: 0.5,
				p: 0.5,
				borderRadius: 99,
				bgcolor: 'common.white',
				boxShadow: '0 1px 2px rgba(28, 43, 54, 0.06)'
			}}
		>
			{options.map(option => {
				const active = option.value === value

				return (
					<ButtonBase
						key={option.value}
						role="radio"
						aria-checked={active}
						onClick={() => onChange(option.value)}
						sx={{
							px: { xs: 2.5, md: 3.5 },
							py: 1.25,
							borderRadius: 99,
							fontSize: 15,
							fontWeight: active ? 700 : 500,
							color: active ? 'primary.contrastText' : 'text.secondary',
							bgcolor: active ? 'primary.dark' : 'transparent',
							transition: 'background-color .3s, color .3s',
							'&:hover': { color: active ? 'primary.contrastText' : 'text.primary' }
						}}
					>
						{option.label}
					</ButtonBase>
				)
			})}
		</Box>
	)
}

export default PricingPeriodToggleMolecule
